import axios from 'axios';
import ResponseErrorHandel from "../ReponseErrorHandeler/StatusHandel.js";

const apiRequests = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000,
})

export default apiRequests;

apiRequests.interceptors.request.use(
    config => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        console.log("error ", error);
        return Promise.reject(error);
    }
)

apiRequests.interceptors.response.use(
    (res) => {
        return res;
    },
    error => {
        ResponseErrorHandel(error);
        return Promise.reject(error);
    }
)
